var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailFfdd00(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8755 15.3798H2.55052C2.0677 15.3783 1.59502 15.241 1.18657 14.9835C0.778124 14.726 0.450385 14.3588 0.240822 13.9239L8.62578 8.77904L10.213 9.75329L11.7893 8.77904L20.1852 13.9239C19.9756 14.3588 19.6479 14.726 19.2394 14.9835C18.831 15.241 18.3583 15.3783 17.8755 15.3798ZM20.426 12.5775L13.0481 8.0347L20.4479 3.50287L20.426 12.5775ZM0 12.5775V3.50287L7.39977 8.0347L0 12.5775ZM10.213 8.19892L0.0547354 1.99226C0.183654 1.42663 0.500756 0.92154 0.954153 0.559618C1.40755 0.197697 1.97038 0.000374433 2.55052 4.82109e-06H17.8755C18.4548 -0.00112354 19.017 0.195847 19.469 0.558215C19.921 0.920584 20.2355 1.42658 20.3603 1.99226L10.213 8.19892Z",
    fill: "#FFDD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFfdd00);
export default __webpack_public_path__ + "static/media/email_ffdd00.18bab8b2d46a797e7121e4f6882c1402.svg";
export { ForwardRef as ReactComponent };